import BaseModel from "../BaseModel";
import Sample from "./Sample";

export default class ReleaseQueue extends BaseModel {
	static entity = 'releaseQueue';
	static primaryKey = "uuid";
	static fields(){
		return {
			uuid: this.attr(null),
			sample_uuid: this.attr(null),
			status: this.attr(null),
			amend: this.attr(null),
			is_ready: this.attr(null),
			leaf_only: this.attr(null),
			reported_only: this.attr(null),
			email_sent: this.attr(false),
			processed_data: this.attr(false,(data) => {
				if(!data) return data;
				if(typeof data === "object") return data;
				return JSON.parse(data);
			}),
			sample: this.belongsTo(Sample, 'uuid', 'uuid'),
			ref: this.attr(null),
		}
	}
}
